<div class="input-field-border-colors" (click)="OnClick()">
  <ng-template formBuilderControlHost ></ng-template>
</div>
